module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image8-64b9607f532ff6ec481cdb78821de9ad.png";